import { ITableReport, Report } from "../../Interfaces/TableInterfaces";
import { CommonTableUI } from "../TableTemplate/common";
import "../../Components/OrderPreviewInstrument.css";

interface ExcelStepOrderPreviewRow extends ITableReport {
  insName?: string | null;
  direction?: string | null;
  optionOrderTypeStr?: string | null;
}

const ExcelStepOrderPreviewTable = <TRow extends ExcelStepOrderPreviewRow>({ reports }: {
  reports: Report<TRow>;
}) => {
  const hasInstrumentColumn = reports.translatedHeaders?.some(
    (header) => header.headerName === "InsName" && header.positionTypeStr === "FirstPage"
  );
  const previewReport = hasInstrumentColumn ? {
    ...reports,
    translatedHeaders: reports.translatedHeaders
      .filter((header) => header.headerName !== "Direction" && header.headerName !== "OptionOrderTypeStr")
      .map((header) => header.headerName === "InsName"
        ? { ...header, headerSubtitle: "جهت / نوع معامله" }
        : header),
  } : reports;

  return <CommonTableUI
    reports={previewReport}
    tableBoxClassName="compact-order-preview compact-order-preview-wide"
    renderCell={(row, header) => {
      if (!hasInstrumentColumn || header.headerName !== "InsName" || (!row.direction && !row.optionOrderTypeStr))
        return undefined;

      return <div className="order-preview-instrument">
        <div className="order-preview-instrument-name">{row.insName || "—"}</div>
        <div className="order-preview-instrument-details">
          <span className={row.direction === "خرید" ? "text-green-600" : row.direction === "فروش" ? "text-red-700" : undefined}>
            {row.direction || "—"}
          </span>
          {row.optionOrderTypeStr ? <>
            <span aria-hidden="true">·</span>
            <span dir="ltr">{row.optionOrderTypeStr}</span>
          </> : null}
        </div>
      </div>;
    }}
  />;
};

export default ExcelStepOrderPreviewTable;
